import React from 'react';
import { Textarea } from '@roger/ui-components';
import { useAutoSave } from '../../../hooks/useAutoSave';
import { getAutoSaveStatusDisplay } from '../../autoSaveStatusDisplay';

interface AutoSaveCommentsProps {
  value: string;
  onSave: (newValue: string) => Promise<void>;
  placeholder?: string;
  className?: string;
  debounceDelay?: number;
}

export const AutoSaveComments: React.FC<AutoSaveCommentsProps> = ({
  value,
  onSave,
  placeholder = 'Add notes or comments...',
  className = '',
  debounceDelay = 1500,
}) => {
  const {
    value: localValue,
    setValue,
    saveStatus,
    saveNow,
  } = useAutoSave({
    initialValue: value,
    onSave,
    debounceDelay,
  });

  const display = getAutoSaveStatusDisplay(saveStatus);

  return (
    <div className='relative'>
      <Textarea
        value={localValue}
        onChange={e => setValue(e.target.value)}
        onBlur={saveNow}
        placeholder={placeholder}
        className={`min-h-[100px] text-sm pr-20 ${className}`}
      />
      {/* Save status indicator */}
      {display && (
        <div className='absolute top-2 right-2 flex items-center gap-1 text-xs bg-white/90 px-1.5 py-0.5 rounded'>
          <span className={`${display.textClass} flex items-center gap-1`}>
            <display.Icon
              className={`h-3 w-3${display.spin ? ' animate-spin' : ''}`}
            />
            {display.label}
          </span>
        </div>
      )}
    </div>
  );
};
